(() => {
  if (window.rudcaPackSelectorReady) return;
  window.rudcaPackSelectorReady = true;
  const origins = new WeakMap();
  function close(dialog) {
    dialog.close();
    const trigger = origins.get(dialog);
    if (trigger?.isConnected) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus({preventScroll: true}); }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-rudca-pack-open]');
    if (trigger) {
      const card = trigger.closest('[data-rudca-pack-card]');
      const dialog = card?.querySelector('[data-rudca-pack-dialog]');
      if (!dialog) return;
      event.preventDefault();
      card.closest('rudca-photo-scroll')?.cancelPendingAdd?.(card.dataset.photoControl);
      origins.set(dialog, trigger);
      trigger.setAttribute('aria-expanded', 'true');
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('cancel', e => { e.preventDefault(); close(dialog); });
        dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(dialog); } });
      }
      dialog.showModal();
      return;
    }
    const closing = event.target.closest('[data-rudca-pack-close]');
    if (closing) { close(closing.closest('dialog')); return; }
    const option = event.target.closest('[data-rudca-pack-option]');
    if (!option || option.disabled) return;
    const card = option.closest('[data-rudca-pack-card]');
    const form = card?.querySelector('form');
    if (!form || form.getAttribute('aria-busy') === 'true') return;
    const input = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    const rules = JSON.parse(form.querySelector('[data-rudca-pack-rules]').textContent)[option.dataset.variantId];
    if (!rules) return;
    const photoHost = card.closest('rudca-photo-scroll');
    if (photoHost) photoHost.cancelPendingAdd?.(card.dataset.photoControl);
    input.value = option.dataset.variantId;
    quantity.value = String(rules.min || 1);
    const metadata = form.querySelector('[data-rudca-basket-selected], [data-rudca-quantity]');
    if (metadata) {
      metadata.dataset.variantId = input.value;
      metadata.dataset.min = String(rules.min || 1);
      metadata.dataset.step = String(rules.step || 1);
      for (const key of ['max', 'stockMax']) {
        if (rules[key] == null) delete metadata.dataset[key];
        else metadata.dataset[key] = String(rules[key]);
      }
    }
    card.dataset.rudcaVariantAvailable = String(rules.available);
    card.dataset.rudcaVariantMin = String(rules.min || 1);
    if (rules.stockMax == null && rules.max == null) delete card.dataset.rudcaVariantMax;
    else card.dataset.rudcaVariantMax = String(Math.min(rules.stockMax ?? Infinity, rules.max ?? Infinity));
    const price = card.querySelector('[data-rudca-pack-price]');
    if (price) price.textContent = option.dataset.packPrice;
    if (photoHost) {
      const photoItem = photoHost.querySelector('[data-photo-item="' + card.dataset.photoControl + '"]');
      const photoPrice = photoItem?.querySelector('.rudca-photo-scroll__price');
      if (photoPrice) photoPrice.textContent = option.dataset.packPrice;
      const photoLink = photoItem?.querySelector('[data-photo-link]');
      if (photoLink) photoLink.setAttribute('aria-label', card.getAttribute('aria-label') + ', ' + option.dataset.packPrice);
    }
    card.querySelector('[data-rudca-pack-label]').textContent = option.dataset.packLabel;
    card.querySelectorAll('[data-rudca-pack-option]').forEach(item => item.setAttribute('aria-pressed', String(item === option)));
    input.dispatchEvent(new Event('change', {bubbles: true}));
    close(option.closest('dialog'));
  });
})();

